(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/models/result.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/models/result.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.models = svs.matchen.models || {};

  svs.matchen.models.Result = Backbone.Model.extend({
    defaults: function() {
      return JSON.parse(JSON.stringify({
        home: '',
        away: '',
        selected: false
      }));
    },

    getHomeResult: function() {
      return this.get('home');
    },

    getAwayResult: function() {
      return this.get('away');
    },

    setSelected: function(value, options) {
      this.set('selected', value, options);
    },

    isHomeWin: function() {
      return this.compareResults('>');
    },

    isAwayWin: function() {
      return this.compareResults('<');
    },

    isDraw: function() {
      return this.compareResults('==');
    },

    compareResults: function(comparator) {
      var home = this.get('home');
      var away = this.get('away');

      if (this.isValidResult(home) && this.isValidResult(away)) {
        if (comparator == '>') {
          return home > away;
        } else if (comparator == '==') {
          return home == away;
        } else if (comparator == '<') {
          return home < away;
        }
      } else {
        return false;
      }
    },

    isValidResult: function() {
      var home = this.get('home');
      var away = this.get('away');

      return home !== '' || away !== '';
    },

    getFormattedResult: function(options) {
      options = _.defaults({}, options, {
        withMarkup: true,
        withSpace: true
      });

      var formattedResult;

      if (options.withMarkup) {
        if (this.isHomeWin()) {
          formattedResult =
            '<strong>' +
            this.getHomeResult() +
            '</strong> - ' +
            this.getAwayResult();
        } else if (this.isAwayWin()) {
          formattedResult =
            this.getHomeResult() +
            ' - <strong>' +
            this.getAwayResult() +
            '</strong>';
        } else if (this.isDraw()) {
          formattedResult = this.getHomeResult() + ' - ' + this.getAwayResult();
        }
      } else {
        formattedResult = this.getHomeResult() + ' - ' + this.getAwayResult();
      }

      if (!options.withSpace) {
        formattedResult = formattedResult.replace(/ /g, ''); 
      }

      return formattedResult;
    },

    compareTo: function(result) {
      if (result instanceof svs.matchen.models.Result) {
        if (this.getHomeResult() < result.getHomeResult()) {
          return -1;
        } else if (this.getHomeResult() > result.getHomeResult()) {
          return 1;
        }
        if (this.getAwayResult() < result.getAwayResult()) {
          return -1;
        } else if (this.getAwayResult() > result.getAwayResult()) {
          return 1;
        }
        return 0;
      }
    }
  });
})(Backbone, _, svs);


 })(window);